// extracted by extract-css-chunks-webpack-plugin
module.exports = {"progressTitle":"_10-V0Q","progressBarBackground":"_1r52Ha","progressBarValue":"_2eVfuY","progressBar":"_3IVM0D"};